/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Status_InitializingInputs */

const en_conversion_status_initializing = /** @type {(inputs: Conversion_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initializing`)
};

const es_conversion_status_initializing = /** @type {(inputs: Conversion_Status_InitializingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicializando`)
};

/**
* | output |
* | --- |
* | "Initializing" |
*
* @param {Conversion_Status_InitializingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_status_initializing = /** @type {((inputs?: Conversion_Status_InitializingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Status_InitializingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_status_initializing(inputs)
	return en_conversion_status_initializing(inputs)
});